import { useLocale } from 'next-intl';

import { PATH_ICON } from '@/app/_constant/icons';
import { cn } from '@/app/_helper/tailwind';
import ScrollableWrapper from '@/modules/scrollable/ScrollableWrapper';

type BuildingInfoProps = {
    bedroom?: string;
    bathroom?: string;
    carports?: string;
    buildingSize?: string;
    landSize?: string;
    className?: string;
    iconClassName?: string;
};

const BuildingInfo = ({
    bedroom,
    bathroom,
    carports,
    buildingSize,
    landSize,
    className,
    iconClassName
}: BuildingInfoProps) => {
    const locale = useLocale();
    return (
        <ScrollableWrapper
            className={cn(
                'flex items-center gap-x-2 text-accent font-medium text-sm',
                className,
            )}
        >
            {Boolean(bedroom) && (
                <span className='flex items-center gap-x-1'>
                    <svg
                        className={cn('text-greyText', iconClassName)}
                        width='16'
                        height='14'
                        viewBox='0 0 16 14'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <use
                            xlinkHref={`${PATH_ICON}SearchPageIcons.svg#bedroom-icon`}
                        />
                    </svg>
                    {bedroom}
                </span>
            )}
            {Boolean(bathroom) && (
                <span className='flex items-center gap-x-1'>
                    <svg
                        className={cn('text-greyText', iconClassName)}
                        width='14'
                        height='15'
                        viewBox='0 0 14 15'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <use
                            xlinkHref={`${PATH_ICON}SearchPageIcons.svg#bathroom-icon`}
                        />
                    </svg>

                    {bathroom}
                </span>
            )}
            {Boolean(carports) && (
                <span className='flex items-center gap-x-1'>
                    <svg
                        className={cn('text-greyText', iconClassName)}
                        width='15'
                        height='15'
                        viewBox='0 0 15 15'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <use
                            xlinkHref={`${PATH_ICON}SearchPageIcons.svg#carports-icon`}
                        />
                    </svg>

                    {carports}
                </span>
            )}
            {Boolean(landSize) && (
                <span className='flex'>
                    <span className={cn('text-greyText', iconClassName)}>
                        {locale === 'en' ? 'LA' : 'LT'}:&nbsp;
                    </span>{' '}
                    {landSize}
                </span>
            )}
            {Boolean(buildingSize) && (
                <span className='flex'>
                    <span className={cn('text-greyText', iconClassName)}>
                        {locale === 'en' ? 'BA' : 'LB'}:&nbsp;
                    </span>{' '}
                    {buildingSize}
                </span>
            )}
        </ScrollableWrapper>
    );
};

export default BuildingInfo;
